import { User, UserRole } from '@core';
import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'MENUITEMS.MASTER.TEXT',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin],
    submenu: [],
  },
  {
    path: '/master/dashboard/main',
    title: 'DASHBOARD.TEXT',
    iconType: 'feather',
    icon: 'monitor',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin],
    submenu: [],
  },
  {
    path: '/master/partners',
    title: 'MODELS.PARTNER.LIST',
    iconType: 'feather',
    icon: 'users',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin],
    submenu: [],
  },
  {
    path: '/master/plans',
    title: 'MODELS.PLAN.LIST',
    iconType: 'feather',
    icon: 'trello',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.REGISTRATIONS.TEXT',
    iconType: 'feather',
    icon: 'file',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin],
    submenu: [
      {
        path: '/master/currencies',
        title: 'MODELS.CURRENCY.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin],
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'MENUITEMS.ADMIN.TEXT',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin],
    submenu: [],
  },

  // Admin Modules
  {
    path: '/admin/dashboard/main',
    title: 'DASHBOARD.TEXT',
    iconType: 'feather',
    icon: 'monitor',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin],
    submenu: [],
  },
  {
    path: '/admin/companies',
    title: 'MODELS.COMPANY.LIST',
    iconType: 'feather',
    icon: 'briefcase',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin],
    submenu: [],
  },
  {
    path: '/admin/users',
    title: 'MODELS.USER.LIST',
    iconType: 'feather',
    icon: 'users',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.REGISTRATIONS.TEXT',
    iconType: 'feather',
    icon: 'map-pin',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin],
    submenu: [
      {
        path: '/admin/registers/countries',
        title: 'MODELS.ADDRESS.COUNTRY.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin],
        submenu: [],
      },
      {
        path: '/admin/registers/states',
        title: 'MODELS.ADDRESS.STATE.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin],
        submenu: [],
      },
      {
        path: '/admin/registers/cities',
        title: 'MODELS.ADDRESS.CITY.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin],
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'MODELS.COMPANY.TEXT',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.REGISTRATIONS.TEXT',
    iconType: 'feather',
    icon: 'file',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
    submenu: [
      {
        path: '/company/registers/suppliers',
        title: 'MODELS.SUPPLIER.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
        submenu: [],
      },
      {
        path: '/company/registers/species',
        title: 'MODELS.SPECIE.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
        submenu: [],
      },
      {
        path: '/company/registers/makes',
        title: 'MODELS.MAKE.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
        submenu: [],
      },
      {
        path: '/company/registers/models',
        title: 'MODELS.MODEL.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin],
        submenu: [],
      }
    ],
  },
  {
    path: '',
    title: 'MODELS.ENTERPRISE.TEXT',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [],
  },
  // Client Modules
  {
    path: '/enterprise/dashboard',
    title: 'DASHBOARD.TEXT',
    iconType: 'feather',
    icon: 'monitor',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [],
  },
  {
    path: '',
    title: 'MODELS.CONFIG.LIST',
    iconType: 'feather',
    icon: 'settings',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
    submenu: [
      {
        path: '/enterprise/configs/enterprise',
        title: 'MODELS.ENTERPRISE.TEXT',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
      {
        path: '/enterprise/configs/accounting-area',
        title: 'MODELS.ACCOUNTING-AREA.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/configs/notifications',
        title: 'MENUITEMS.NOTIFICATIONS.TEXT',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.REGISTRATIONS.TEXT',
    iconType: 'feather',
    icon: 'file',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [
      {
        path: '/enterprise/registers/asset-categories',
        title: 'MODELS.ASSET-CATEGORY.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/registers/writeoff-reason',
        title: 'MODELS.WRITEOFF-REASON.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      }
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.CLASSIFICATIONS.TEXT',
    iconType: 'feather',
    icon: 'grid',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [
      {
        path: '/enterprise/classifications/accounts',
        title: 'MODELS.ACCOUNT.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/classifications/business-units',
        title: 'MODELS.BUSINESS-UNIT.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/classifications/costs',
        title: 'MODELS.COST.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/classifications/locals',
        title: 'MODELS.LOCAL.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/classifications/aux-tables',
        title: 'MODELS.AUX-TABLE.LIST',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      }
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.OPERATION.LIST',
    iconType: 'feather',
    icon: 'zap',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [
      // --- Grupo 1: Ativos e operações sobre ativos ---
      {
        path: '/enterprise/operations/assets',
        title: 'MENUITEMS.OPERATION.ASSETS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/writeoff-revert',
        title: 'MENUITEMS.OPERATION.WRITEOFF-REVERT',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/transfer-revert',
        title: 'MENUITEMS.OPERATION.TRANSFER-REVERT',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/depreciation-resume',
        title: 'MENUITEMS.OPERATION.DEPRECIATION-RESUME',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      // --- Separador ---
      {
        path: '',
        title: '',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
        separator: true,
      },
      // --- Grupo 2: Impairments, Manutenções, Projetos, Reavaliações ---
      {
        path: '/enterprise/operations/impairments',
        title: 'MENUITEMS.OPERATION.IMPAIRMENTS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
      {
        path: '/enterprise/operations/maintenances',
        title: 'MAINTENANCE.LIST',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/projects',
        title: 'PROJECT.LIST',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/revaluations',
        title: 'MENUITEMS.OPERATION.REVALUATIONS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
      // --- Separador ---
      {
        path: '',
        title: '',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
        separator: true,
      },
      // --- Grupo 3: Período ---
      {
        path: '/enterprise/operations/advance-period',
        title: 'MENUITEMS.OPERATION.ADVANCE-PERIOD',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/operations/revert-period',
        title: 'MENUITEMS.OPERATION.REVERT-PERIOD',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/shared/operations/imports',
        title: 'MENUITEMS.OPERATION.IMPORTS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      }
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.REPORT.LIST',
    iconType: 'feather',
    icon: 'file-text',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [
      {
        path: '/enterprise/reports/analytical',
        title: 'MENUITEMS.REPORT.ANALYTICAL',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/acquisitions',
        title: 'MENUITEMS.REPORT.ACQUISITIONS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/write-offs',
        title: 'MENUITEMS.REPORT.WRITEOFFS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/transfers',
        title: 'MENUITEMS.REPORT.TRANSFERS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/total-depreciateds',
        title: 'MENUITEMS.REPORT.TOTAL-DEPRECIATED',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/balances-account',
        title: 'MENUITEMS.REPORT.BALANCES-ACCOUNT',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/balances-cost',
        title: 'MENUITEMS.REPORT.BALANCES-COST',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/revaluations',
        title: 'MENUITEMS.REPORT.REVALUATIONS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/impairments',
        title: 'MENUITEMS.REPORT.IMPAIRMENTS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/reports/intangibles',
        title: 'MENUITEMS.REPORT.INTANGIBLES',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.EXPORT.TEXT',
    iconType: 'feather',
    icon: 'download',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.All],
    submenu: [
      {
        path: '/enterprise/exports/basic',
        title: 'MENUITEMS.EXPORT.BASIC',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
      {
        path: '/enterprise/exports/advanced',
        title: 'MENUITEMS.EXPORT.ADVANCED',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.All],
        submenu: [],
      },
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.AUDIT.TEXT',
    iconType: 'feather',
    icon: 'shield',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
    submenu: [
      {
        path: '/enterprise/audit/logs',
        title: 'MENUITEMS.AUDIT.LOGS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
      {
        path: '/enterprise/audit/import-history',
        title: 'MENUITEMS.AUDIT.IMPORT-HISTORY',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.Admin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin],
        submenu: [],
      },
    ]
  }
];
